module.exports = __webpack_public_path__ + "img/return-icon-active.58550634.svg";